export enum ShipBuildType {
  Pod,
  Shuttlecraft,
  Runabout,
  Starship,
}
